// named export (recommended)
export const COLLABORATE = {
    // section: ["overviewSection", "roiInvestorBenefits", "investmentOpportunity", "commercialOperationalBenefits", "communicationChannel"],
    href: "/investments/collaborate",
    overviewSection: {
        sectionId: "rentalInvestment",
        title: "Overview",
        subtitle:
            "RSL Commercial Brokers is a Dubai-based platform that connects entrepreneurs, investors, and business owners to buy and sell businesses across industries.",
        cards: [
            {
                title: "Business Listings",
                body: "Sellers showcase their businesses on the platform.",
                arrow: "/img/app/Right-top-arrow.svg",
            },
            {
                title: "Buyer Access",
                body: "Investors explore vetted opportunities matching their needs.",
                arrow: "/img/app/Right-bottom-arrow.svg",
            },
            {
                title: "Deal Support",
                body: "RSL manages negotiations, due diligence, and compliance.",
                arrow: "/img/app/Right-top-arrow.svg",
            },
            {
                title: "Brokerage Fee",
                body: "20% charged on successful deal closure.",
            },
        ],
        button: { text: "Invest Now", link: "#" },
    },
    roiInvestorBenefits: {
        sectionId: "overview",
        title: "ROI & Investor Benefits",
        subtitle:
            "Choose which suits you better",
        image: {
            src: "/img/investments/collaborate/collaborate.svg",
            alt: " Hands offering coins"
        },
        button: { text: "Invest Now", link: "#" },
        bgcolor: "#f9f9f9",
    },
    investmentOpportunity: {
        sectionId: "opportunityForInvestment",
        title: "Operating Model",
        subtitle:
            "Make journey comfortable with",
        cardData: [
            {
                title: "Business Onboarding & Vetting",
                description: [
                    "Seller submits a request to list their business.",
                    "RSL conducts verification according to the Business Vetting & Verification Checklist.",
                    "Approved businesses go live on Marketplace.",
                ],
                icon: "/img/investments/limousine/card1.svg",
                vector: "/img/investments/commercial/vector1.svg", // BR (bottom-right)
                arcSide: "right",
                arcAnchor: "bottom",
            },
            {
                title: "Marketplace Listing",
                description: [
                    "Businesses are presented with detailed profiles, financials highlights, key investment Sponsored marketing campaigns amplify visibility to attract serious buyers.",
                ],
                icon: "/img/investments/limousine/card2.svg",
                vector: "/img/investments/commercial/vector2.svg", // BL (bottom-left)
                arcSide: "left",
                arcAnchor: "bottom",
            },
            {
                title: "Deal Closure",
                description: [
                    "Brokerage fee will be 20% of total transaction value",
                    "AED 5,000 charged upon onboarding/listing, non-refundable, covering marketing, operations, and administrative costs.",
                ],
                icon: "/img/investments/limousine/card3.svg",
                vector: "/img/investments/commercial/vector3.svg", // TL (top-left)
                arcSide: "right",
                arcAnchor: "top",
            },
            {
                title: "Buyer Engagement",
                description: [
                    "Interested buyers/investors request access to additional details under NDA.",
                    "RSL facilitates meetings and negotiations."
                ],
                icon: "/img/investments/limousine/card4.svg",
                vector: "/img/investments/commercial/vector4.svg", // TR (top-right)
                arcSide: "left",
                arcAnchor: "top",
            },
        ]
    },
    commercialOperationalBenefits: {
        subtitle: "Choose which suits you better",
        title: "Operational Benefits",
        accentColor: "#0F7F8A",
        sellers: {
            title: "For Sellers",
            icons: "/img/investments/commercial/oval1.svg",
            items: [
                "Access to a professional, global investor pool",
                "Confidential listing process with NDA protections",
                "Marketing campaigns targeting relevant buyers",
                "End-to-end transaction support",
            ],
        },
        buyers: {
            title: "For Buyers/Investors",
            icons: "/img/investments/commercial/oval2.svg",
            items: [
                "Access to vetted businesses with verified documentation",
                "Transparent deal information, reducing risk",
                "Streamlined acquisition process with RSL facilitation",
                "Support in diligence & contract structuring",
            ],
        },
        strategic: {
            title: "Strategic Value to RSL",
            icons: "/img/investments/commercial/oval3.svg",
            items: [
                "Trusted commercial brokerage in Dubai",
                "Diversifies revenue through transaction-based brokerage fees",
                "Strengthens RSL’s network across industries",
                "Builds long-term relationships with entrepreneurs, investors, and SMEs",
            ],
        },
        images: {
            rightTop: { src: "/img/investments/commercial/for-sale.svg", alt: "For sale" },
            leftMiddle: { src: "/img/investments/commercial/agent-tour.svg", alt: "Agent showing property" },
            rightBottom: { src: "/img/investments/commercial/team-fistbump.svg", alt: "Team support" },
        },
        button: { text: "Invest Now", link: "#" },
    },
    communicationChannel: {
        sectionId: "communicationChannel",
        title: "Communication Channel",
        subtitle:
            "Choose which suits you better",
        bottomHeader: "RSL ensures smooth communication and transparency for all investors and drivers:",
        cardData: [
            {
                heading: "Call Center (UAE):",
                iconSrc: "/img/investments/phone.svg",
                iconAlt: "Phone",
                url: [
                    {
                        href: "tel:+97143977746",
                        label: "+971 4 397 7746"
                    }
                ]
            },
            {
                heading: "Email (Investors):",
                iconSrc: "/img/investments/email.svg",
                iconAlt: "Email",
                url: [
                    {
                        href: "mailto:investors@royalsmartlifestyle.com",
                        label: "investors@royalsmartlifestyle.com"
                    }
                ]
            },
            {
                heading: "Websites",
                iconSrc: "/img/investments/globe.svg",
                iconAlt: "Globe",
                url: [{
                    href: "https://www.royalsmartlimousine.com",
                    label: "https://www.royalsmartlimousine.com"
                }]
            }
        ],
        image: {
            src: "/images/bannerImage/rsl_super_app.svg",
            alt: "RSL SUPER APP"
        }
    }
};

export const COLLABORATE_page = {
    roiInvestorBenefits: {
        sectionId: "overview",
        title: "Let's Collaborate With RSL, Where Innovation Meets Opportunity",
        subtitle:
            "Overview",
        image: {
            src: "/img/investments/collaborate/collaborate.svg",
            alt: "RSL-Purchased Vehicle"
        },
        bgcolor: "#ffffff",
        width: "100%",
        button: { text: "Let's work together", link: "#" },
        whatsappButton: { text: "Send a message", link: "#" },
    },
    carToInvest: {
        sectionId: "Make journey comfortable with",
        title: "Benefits Of Collaborating With RSL",
        subtitle:
            "Make journey comfortable with",
        image: {
            src: "/img/investments/collaborate/benefits.svg",
            alt: " Hands offering coins"
        },
        button: { text: "Let's work together", link: "#" },
        bgcolor: "#fff",
    },
    trustedPartners: {
        sectionId: "trustedPartners",
        title: "Our Trusted Partner",
        subtitle:
            "Make journey comfortable with",
        logos: [
            { name: "gumroad", src: "/img/investments/limousine/partner/gumroad.svg" },
            { name: "Google", src: "/img/investments/limousine/partner/google.svg" },
            { name: "coinbase", src: "/img/investments/limousine/partner/coinbase.svg" },
            { name: "gusto", src: "/img/investments/limousine/partner/gusto.svg" },
            { name: "HashiCorp", src: "/img/investments/limousine/partner/hashicorp.svg" },
            { name: "zoom", src: "/img/investments/limousine/partner/zoom.svg" },
            { name: "stripe", src: "/img/investments/limousine/partner/stripe.svg" },

            { name: "Instagram", src: "/img/investments/limousine/partner/instagram.svg" },
            { name: "Linear", src: "/img/investments/limousine/partner/linear.svg" },
            { name: "mailchimp", src: "/img/investments/limousine/partner/mailchimp.svg" },
            { name: "Medium", src: "/img/investments/limousine/partner/medium.svg" },
            { name: "Microsoft", src: "/img/investments/limousine/partner/microsoft.svg" },
            { name: "NETFLIX", src: "/img/investments/limousine/partner/netflix.svg" },

            { name: "Notion", src: "/img/investments/limousine/partner/notion.svg" },
            { name: "Outreach", src: "/img/investments/limousine/partner/outreach.svg" },
            { name: "PayPal", src: "/img/investments/limousine/partner/paypal.svg" },
            { name: "Razorpay", src: "/img/investments/limousine/partner/razorpay.svg" },
            { name: "slack", src: "/img/investments/limousine/partner/slack.svg" },
            { name: "Spotify", src: "/img/investments/limousine/partner/spotify.svg" },

            { name: "tinder", src: "/img/investments/limousine/partner/tinder.svg" },
            { name: "treehouse", src: "/img/investments/limousine/partner/treehouse.svg" },
            { name: "Trello", src: "/img/investments/limousine/partner/trello.svg" },
            { name: "twitch", src: "/img/investments/limousine/partner/twitch.svg" },
            { name: "Uber", src: "/img/investments/limousine/partner/uber.svg" },
            { name: "webflow", src: "/img/investments/limousine/partner/webflow.svg" },
            { name: "YouTube", src: "/img/investments/limousine/partner/youtube.svg" },
        ]
    },
    communicationChannel: {
        sectionId: "communicationChannel",
        image: {
            src: "/images/bannerImage/rsl_super_app.svg",
            alt: "RSL SUPER APP"
        }
    }
}